import { createSlice } from "@reduxjs/toolkit";
const initialPersonState = {
  nationalIdNumber: null,
  name: false,
  lastName: null,
  address: null,
  phone: null,
  email: null,
  role: null,
  contracts: {
    data: [],
    loading: false,
    error: null,
  },
};

const personSlice = createSlice({
  name: "person",
  initialState: initialPersonState,
  reducers: {
    setName(state, action) {
      state.name = action.payload;
    },
    setLastName(state, action) {
      state.lastName = action.payload;
    },
    setRole(state, action) {
      state.role = action.payload;
    },
  },
});

export const personActions = personSlice.actions;

export default personSlice.reducer;
